import CompanyInfoSection from './CompanyInfoSection';
import FiscalConfigSection from './FiscalConfigSection';
import TextSections from './TextSections';
import { BusinessConfigurationForm as FormType } from '../../types/business/BusinessTypes';
import BusinessLogosUploader from './BusinessLogoUploader';

interface Option {
  id: number;
  name: string;
  code?: string;
}

interface Props {
  form: FormType;
  errors: Record<string, string>;

  // ✅ Logo para tickets
  logoFile: File | null;
  logoPreviewUrl?: string;
  setLogoFile: (file: File | null) => void;

  // ✅ Logo para DTE
  pdfLogoFile: File | null;
  pdfLogoPreviewUrl?: string;
  setPdfLogoFile: (file: File | null) => void;

  onChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => void;
  onEconomicActivitySelect: (option: Option) => void;
  onEconomicActivitySearch: (text: string) => void;
  onSave: () => void;
  taxpayerCategoryOptions: Option[];
  economicActivityOptions: Option[];
}

const BusinessConfigurationForm = ({
  form,
  errors,
  logoFile,
  logoPreviewUrl,
  setLogoFile,
  pdfLogoFile,
  pdfLogoPreviewUrl,
  setPdfLogoFile,
  onChange,
  onEconomicActivitySelect,
  onEconomicActivitySearch,
  onSave,
  taxpayerCategoryOptions,
  economicActivityOptions,
}: Props) => {
  return (
    <div className="space-y-10 p-4 px-4 py-5">
      <CompanyInfoSection form={form} errors={errors} onChange={onChange} />

      <FiscalConfigSection
        form={form}
        errors={errors}
        onChange={onChange}
        onEconomicActivitySelect={onEconomicActivitySelect}
        onEconomicActivitySearch={onEconomicActivitySearch}
        taxpayerCategoryOptions={taxpayerCategoryOptions}
        economicActivityOptions={economicActivityOptions}
      />


      <TextSections form={form} errors={errors} onChange={onChange} />

      {/* 🔹 Nuevo componente que muestra ambos logos */}
      <BusinessLogosUploader
        logoFile={logoFile}
        logoPreviewUrl={logoPreviewUrl}
        setLogoFile={setLogoFile}
        pdfLogoFile={pdfLogoFile}
        pdfLogoPreviewUrl={pdfLogoPreviewUrl}
        setPdfLogoFile={setPdfLogoFile}
      />

      <div className="mt-6 flex justify-end">
        <button
          type="button"
          onClick={onSave}
          className="rounded bg-primary px-6 py-2.5 font-medium text-white hover:bg-opacity-90"
        >
          Guardar Configuración
        </button>
      </div>
    </div>
  );
};

export default BusinessConfigurationForm;
